import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { useTranslation } from 'react-i18next';
import { SalaryNoticeSection } from '../../components/salary-notice-section.component';
import { HolidayPayReportSection } from '../../components/holiday-pay-report-section.component';
import { PensionReportSection } from '../../components/pensions.component';
import { useState } from 'react';

function MySalaryNoticePage() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('salary-notice');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const tabs = [
        { key: 'salary-notice', label: t('SALARY_LABEL_KEY') },
        { key: 'holiday-pay', label: t('HOLIDAY_PAY_LABEL_KEY') },
        { key: 'pensions', label: t('PENSIONS') }
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'salary-notice':
                return <SalaryNoticeSection />;

            case 'holiday-pay':
                return <HolidayPayReportSection />;

            case 'pensions':
                return <PensionReportSection />;
            default:
                return <SalaryNoticeSection />;
        }
    };

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='salary-notice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='px-3 d-flex' style={{ gap: '24px' }}>
                        {tabs.map(({ key, label }) => (
                            <button
                                key={key}
                                className={`content-tab-btn  ${activeTab.includes(key) ? 'active ' : ''}`}
                                onClick={() => setActiveTab(key)}
                            >
                                <h1 className="dashboard-page__title mb-0 py-3">
                                    {label}
                                </h1>
                            </button>
                        ))}
                    </div>

                    <div className="px-3  gap-3">
                        <div className="tab-content mt-3">
                            {renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MySalaryNoticePage;


